module.exports = __webpack_public_path__ + "img/cooperation.dc3bbb4d.png";